export class VanpoolRate {
  id: number = 0;
  rate: number=0;
  start_date: Date= new Date(0);
  end_date?: Date = new Date(0);
  srdr: boolean = false;
  change_reason: string = "";
}